import { sidebarModelSpecificationId, sidebarComponentId, isUserLoggedIn, organizationProductsFilters, sharedProductsFilters, assigningSharedProductsFilters, assigningMyProductsFilters, organizationSuppliersFilters, organizationOrderOperatorsFilters, } from './cache';
import { pagination, productVariants } from './resolvers';
export default {
    Query: {
        fields: {
            sidebarComponentId: {
                read() {
                    return sidebarComponentId();
                },
            },
            sidebarModelSpecificationId: {
                read() {
                    return sidebarModelSpecificationId();
                },
            },
            isUserLoggedIn: {
                read() {
                    return isUserLoggedIn();
                },
            },
            getDirectConversations: {
                merge(_existing, incoming) {
                    // Replace the entire list with incoming data
                    return incoming;
                },
            },
            getSpecificationAndFolderConversations: {
                merge(_existing, incoming) {
                    // Replace the entire list with incoming data
                    return incoming;
                },
            },
            getChannels: {
                merge(_existing, incoming) {
                    // Replace the entire list with incoming data
                    return incoming;
                },
            },
        },
    },
    UserNode: {
        fields: {
            modelSpecifications: pagination,
            modelSpecificationsSharedWith: pagination,
            timings: pagination,
            organizationProductsFilters: {
                read() {
                    return organizationProductsFilters();
                },
            },
            sharedProductsFilters: {
                read() {
                    return sharedProductsFilters();
                },
            },
            organizationSuppliersFilters: {
                read() {
                    return organizationSuppliersFilters();
                },
            },
            organizationOrderOperatorsFilters: {
                read() {
                    return organizationOrderOperatorsFilters();
                },
            },
        },
    },
    ProductNode: {
        fields: {
            variants: Object.assign({ keyArgs: ['status', 'colorId'] }, pagination),
        },
    },
    TenantNode: {
        fields: {
            brands: pagination,
            categories: pagination,
            seasons: pagination,
            sizes: pagination,
            elements: Object.assign({ keyArgs: ['name'] }, pagination),
            templates: Object.assign({ keyArgs: ['name'] }, pagination),
            suppliers: Object.assign({ keyArgs: ['name', 'status', 'isPublic', 'products_CategoryId'] }, pagination),
            products: Object.assign({ keyArgs: ['id', 'name', 'categoryId', 'supplierId', 'status'] }, pagination),
            timingTasks: Object.assign({ keyArgs: ['id', 'type_Code', 'name', 'category'] }, pagination),
            orderOperators: Object.assign({ keyArgs: ['name'] }, pagination),
        },
    },
    TimingTaskNode: {
        fields: {
            type: {
                merge(existing, incoming) {
                    return Object.assign(Object.assign({}, existing), incoming);
                },
            },
        },
    },
    TimingFolderNode: {
        fields: {
            timings: pagination,
        },
    },
    TimingNode: {
        fields: {
            items: pagination,
        },
    },
    ComponentNode: {
        assigningSharedProductsFilters: {
            read() {
                return assigningSharedProductsFilters();
            },
        },
        assigningMyProductsFilters: {
            read() {
                return assigningMyProductsFilters();
            },
        },
    },
    Autocomplete: {
        fields: {
            productVariants,
            unassignedProducts: Object.assign({ keyArgs: ['categoryId', 'name', 'supplierId', 'id'] }, pagination),
            timingTasks: pagination,
            modelSpecificationTemplateElements: pagination,
            modelSpecificationTemplates: pagination,
            productFunctions: Object.assign({ keyArgs: ['name'] }, pagination),
            productSustainabilities: Object.assign({ keyArgs: ['name'] }, pagination),
            productCertificates: Object.assign({ keyArgs: ['name'] }, pagination),
            productContinents: Object.assign({ keyArgs: ['name'] }, pagination),
            productEvents: Object.assign({ keyArgs: ['name'] }, pagination),
            productMainCategories: Object.assign({ keyArgs: ['name'] }, pagination),
        },
    },
};
